export default __webpack_public_path__ + "static/media/catalog_icon.edd358ed.svg";